import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

const DataTableBodyCellDecimal = ({ value }) => {
  return <FormattedNumber value={value} minimumFractionDigits={2} maximumFractionDigits={3} />;
};

DataTableBodyCellDecimal.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default DataTableBodyCellDecimal;
